import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../api";
import { PlainDetails } from "../../types/admin";


export type AdminState = {
    games: PlainDetails[];
    game_plain: PlainDetails | null;
    teams: PlainDetails[];
    team_plain: PlainDetails | null;
    forms: PlainDetails[];
    themes: PlainDetails[];
    error: string | null;
    success: string | null;
};

const initialState: AdminState = {
    games: [],
    game_plain: null,
    teams: [],
    team_plain: null,
    forms: [],
    themes: [],
    error: null,
    success: null
};


export const getPlainThemes = createAsyncThunk(
    "admin/getPlainThemes",
    async (search: string, thunkAPI) => {
        try {
            return await api.get(`/API/admin/themes/plain/?search=${search}`);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const getPlainForms = createAsyncThunk(
    "admin/getPlainForms",
    async (search: string, thunkAPI) => {
        try {
            return await api.get(`/API/admin/forms/plain/?search=${search}`);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const getPlainGames = createAsyncThunk(
    "admin/getPlainGames",
    async (search: string, thunkAPI) => {
        try {
            return await api.get(`/API/admin/games/plain/?search=${search}`);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


export const getPlainTeams = createAsyncThunk(
    "admin/getPlainTeams",
    async (search: string, thunkAPI) => {
        try {
            return await api.get(`/API/admin/teams/plain/?search=${search}`);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const slice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setGame: (state, action) => {
            state.game_plain = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        clearSuccess: (state) => {
            state.success = null;
        },
        toastSuccess: (state, action) => {
            state.success = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPlainGames.fulfilled, (state, action) => {
                state.games = action.payload.games;
            })
            .addCase(getPlainTeams.fulfilled, (state, action) => {
                state.teams = action.payload.teams;
            })
            .addCase(getPlainForms.fulfilled, (state, action) => {
                state.forms = action.payload.forms;
            })
            .addCase(getPlainThemes.fulfilled, (state, action) => {
                state.themes = action.payload.themes;
            })
    }
});

export const {
    setGame,
    clearError,
    clearSuccess,
    toastSuccess
} = slice.actions;
export default slice.reducer;